<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h5 class="mb-3">Search</h5>
                <div class="row">
                    <div class="col">
                        <select2 :options="clientCdOptions" v-model="params.clientCd" :label="'Client Code'"/>
                    </div>
                    <div class="col">
                        <select2 :options="languageOptions" v-model="params.lang" :label="'Language'"/>
                    </div>
                    <div class="col">
                        <input-search v-model="params.searchText" @search="search"  :label="'Name'"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="block-target">
            <div class="card">
                <div class="card-header header-elements-inline pt-2 pb-2">
                    <h5 class="card-title"/>
                    <div class="header-elements w-100">
                        <div class="list-icons">
                            <paging :page-info="pageInfo" @search="search"  v-if="pageInfo.pages.length > 0"/>
                        </div>
                        <div class="list-icons ml-auto">
                            <router-link to="/mail/management/layout/create" class="btn btn-ums" v-if="hasRole($const.ROLES.MAIL_LAYOUT_SAVE)">Create</router-link>
                        </div>
                        <div class="list-icons ml-4">
                            <block-target ref="blockTarget" @search="search" :class="'list-icons-item'"/>
                        </div>
                    </div>
                </div>
            </div>
            <transition name="fade" mode="out-in">
                <ImageTable name="templateImageList" :list="layouts">
                    <template v-slot:overlay="slotData">
                        <div class="caption-overflow">
                            <span>
                                <a href="javascript:void(0)" @click="preview(slotData.data)" class="btn btn-flat border-white text-white btn-rounded btn-icon"><i class="icon-arrow-right8"/></a>
                            </span>
                        </div>
                    </template>
                    <template v-slot:buttons="slotData">
                        <div style="display: flex">
                            <div @click="goToUpdate(slotData.data)" class="ml-auto" v-if="hasRole($const.ROLES.MAIL_LAYOUT_SAVE)">
                                <button  class="option-icon-padding btn">
                                    <i class="icon-pencil3 icon-1x"/>
                                </button>
                            </div>
                            <button  class="option-icon-padding btn" @click="deleteLayout(slotData.data)" v-if="hasRole($const.ROLES.MAIL_LAYOUT_DELETE)">
                                <i class="icon-trash icon-1x" />
                            </button>
                        </div>
                    </template>
                </ImageTable>
            </transition>
        </div>
        <mail-type-preview-modal :target="modalTarget" ref="mailTypePreviewModal"/>
    </div>
</template>

<script>
    import BlockTarget from "@/components/block/BlockTarget";
    import Select2 from "@/components/form/select/Select2";
    import InputSearch from "@/components/form/input/InputSearch";
    import Paging from "@/components/pagination/Paging";
    import api from '@/api/layout'
    import ImageTable from "@/components/form/table/ImageTable";
    import MailTypePreviewModal from "@/components/modal/MailTypePreviewModal";
    export default {
        name: "mail-template-layout",
        components:{
            ImageTable,
            BlockTarget,
            Select2,
            InputSearch,
            Paging,
            MailTypePreviewModal
        },
        data() {
            return {
                modalTarget:'mailLayoutPreviewModal',
                data:[],
                htmlContent:'',
                params:{
                    clientCd:'',
                    lang:'',
                    searchText:'',
                    page:0,
                },
                layouts:[],
                message:'',
                pageInfo:{
                    pages:[1],
                    page:1
                }
            }
        },
        mounted() {
            if(this.legacyParams) this.params = this.legacyParams
            this.search()
        },
        computed: {
            clientCdOptions: function() {
                return this.$store.getters[this.$const.GETTERS.CLIENT_CD_OPTIONS]()
            },
            languageOptions: function() {
                return this.$store.getters[this.$const.GETTERS.LANGUAGE_OPTIONS]()
            },
            legacyParams: function() {
                return this.$store.getters[this.$const.GETTERS.GET_LEGACY_PARAMS]()[this.$route.name]
            }
        },
        methods: {
            search:function(page) {
                typeof page !== 'undefined' ? this.params.page = page : this.params.page = 0
                this.$refs.blockTarget.block()
                api.getLayouts(this.params).then((res) => {
                    let response = this.resObj(res,true)
                    this.layouts = response.content
                    this.pageInfo = response.pageInfo
                }).finally(()=> {
                    this.$refs.blockTarget.unblock()
                })
            },
            preview: function(info) {
                info.tmplContent = 'sample Content'
                this.$refs.mailTypePreviewModal.setData(info,info.indexPath)
                $("#"+ this.modalTarget).modal('toggle')
            },
            deleteLayout:function(item) {
                this.$notify.warningConfirm(item.name,() => {
                    api.deleteLayout(item.layoutId).then(res => {
                        if(res && res.data.code === 1000) {
                            this.$notify.success(res.data.message)
                            this.search()
                        }
                    })
                })
            },
            goToUpdate:function(layout) {
                this.$router.push({name: 'LayoutUpdate', params: {layout:layout}})
            }
        },
        beforeRouteLeave (to, from, next) {
            this.$store.commit(this.$const.MUTATE.SET_LEGACY_PARAMS,{name:from.name,params:this.params})
            next()
        },
    }
</script>

<style scoped>
    .option-icon-padding {
        padding: 0rem .5rem;
        border:0.1rem solid transparent;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
